import React from 'react';
import { X, Phone, ArrowLeft, Loader2 } from 'lucide-react';

const GlobalLoginModal = ({
    showLoginModal,
    setShowLoginModal,
    loginStep,
    setLoginStep,
    phoneNumber,
    setPhoneNumber,
    verificationCode,
    setVerificationCode,
    handleSendOTP,
    handleVerifyOTP,
    authLoading,
    authError,
    t,
    primaryColor
}) => {
    if (!showLoginModal) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(15px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 2000, padding: '1rem'
        }}>
            <style>{`@media (max-width: 400px) { .login-modal-card { padding: 1.5rem !important; border-radius: 24px !important; } .login-modal-card h2 { font-size: 1.375rem !important; } }`}</style>
            <div className="card fade-in login-modal-card" style={{
                width: '100%',
                maxWidth: '400px',
                background: '#ffffff',
                padding: '2.5rem',
                position: 'relative',
                borderRadius: '32px',
                border: '1px solid rgba(0,0,0,0.05)',
                boxShadow: '0 25px 60px -12px rgba(0,0,0,0.15)'
            }}>
                <button
                    onClick={() => setShowLoginModal(false)}
                    style={{
                        position: 'absolute',
                        top: '1.25rem',
                        right: '1.25rem',
                        background: '#f8fafc',
                        padding: '8px',
                        color: '#64748b',
                        border: '1px solid #f1f5f9',
                        borderRadius: '12px',
                        cursor: 'pointer'
                    }}
                >
                    <X size={20} />
                </button>

                <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
                    <div style={{
                        width: '70px',
                        height: '70px',
                        background: `${primaryColor}15`,
                        color: primaryColor,
                        borderRadius: '22px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1.25rem',
                        border: `1px solid ${primaryColor}30`
                    }}>
                        <Phone size={32} strokeWidth={2.5} />
                    </div>
                    <h2 style={{ fontSize: '1.625rem', fontWeight: 900, color: '#1a1412', letterSpacing: '-0.5px' }}>{t('portal.restoreTitle', 'Puanlarını Getir')}</h2>
                    <p style={{ color: '#64748b', fontSize: '0.9375rem', marginTop: '0.75rem', lineHeight: 1.6, fontWeight: 500 }}>
                        {loginStep === 'phone'
                            ? t('portal.restoreDesc', 'Telefon numaranızı girerek kayıtlı puanlarınızı bu cihaza yükleyebilirsiniz.')
                            : t('portal.enterCode', 'Numaranıza gönderilen 6 haneli kodu giriniz.')}
                    </p>
                </div>

                {loginStep === 'phone' ? (
                    <form onSubmit={handleSendOTP}>
                        <div style={{ marginBottom: '1.75rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.75rem', fontSize: '0.75rem', fontWeight: 800, color: '#a69088', textTransform: 'uppercase', letterSpacing: '1px' }}>{t('common.phone', 'Telefon')}</label>
                            <input
                                type="tel"
                                placeholder="5XX XXX XX XX"
                                required
                                value={phoneNumber}
                                onChange={e => setPhoneNumber(e.target.value)}
                                style={{
                                    width: '100%',
                                    textAlign: 'center',
                                    fontSize: '1.25rem',
                                    fontWeight: 800,
                                    padding: '18px',
                                    borderRadius: '18px',
                                    background: '#f8fafc',
                                    border: '1px solid #e2e8f0',
                                    color: '#1a1412',
                                    outline: 'none'
                                }}
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={authLoading || !phoneNumber}
                            style={{
                                width: '100%',
                                padding: '16px',
                                background: primaryColor,
                                borderRadius: '16px',
                                fontSize: '1rem',
                                fontWeight: 900,
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer'
                            }}
                        >
                            {authLoading ? <Loader2 className="animate-spin" size={24} /> : t('portal.sendSMS', 'SMS Gönder')}
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleVerifyOTP}>
                        <div style={{ marginBottom: '1.75rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.75rem', fontSize: '0.75rem', fontWeight: 800, color: '#a69088', textTransform: 'uppercase', letterSpacing: '1px' }}>{t('portal.otpCode', 'Doğrulama Kodu')}</label>
                            <input
                                type="text"
                                placeholder="000000"
                                maxLength={6}
                                required
                                value={verificationCode}
                                onChange={e => setVerificationCode(e.target.value)}
                                style={{
                                    width: '100%',
                                    textAlign: 'center',
                                    fontSize: '2rem',
                                    fontWeight: 900,
                                    letterSpacing: '8px',
                                    padding: '16px',
                                    borderRadius: '18px',
                                    background: '#f8fafc',
                                    border: '1px solid #e2e8f0',
                                    color: primaryColor,
                                    outline: 'none'
                                }}
                            />
                        </div>
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            <button
                                type="button"
                                onClick={() => setLoginStep('phone')}
                                style={{
                                    flex: 1,
                                    background: 'rgba(255,255,255,0.05)',
                                    border: 'none',
                                    color: '#fff',
                                    padding: '16px',
                                    borderRadius: '16px',
                                    cursor: 'pointer'
                                }}
                            >
                                <ArrowLeft size={24} />
                            </button>
                            <button
                                type="submit"
                                disabled={authLoading || verificationCode.length < 6}
                                style={{
                                    flex: 3,
                                    background: primaryColor,
                                    padding: '16px',
                                    borderRadius: '16px',
                                    fontWeight: 900,
                                    fontSize: '1rem',
                                    color: 'white',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                {authLoading ? <Loader2 className="animate-spin" size={24} /> : t('portal.verify', 'Doğrula')}
                            </button>
                        </div>
                    </form>
                )}

                {authError && (
                    <div style={{ marginTop: '1.5rem', padding: '12px', borderRadius: '12px', background: 'rgba(220, 38, 38, 0.1)', color: '#ef4444', fontSize: '0.875rem', textAlign: 'center', border: '1px solid rgba(220, 38, 38, 0.2)' }}>
                        {authError}
                    </div>
                )}

                <div id="recaptcha-container"></div>
            </div>
        </div>
    );
};

export default GlobalLoginModal;
